import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LogtrackingRoutingModule } from './logtracking-routing.module';
import { LogTrackingLinkComponent } from './log-tracking-link/log-tracking-link.component';
import { LogTrackingLandingComponent } from './log-tracking-landing/log-tracking-landing.component';
import { AcademicFormModule, } from '../academic-form/academic-form.module';
import { ModuleRegistry } from "ag-grid-community";
import { AllEnterpriseModule, LicenseManager } from "ag-grid-enterprise";
import { environment } from 'src/environments/environment';
import { AgGridModule } from 'ag-grid-angular';
import { AgGridAngular } from "ag-grid-angular";
import { HttpClientModule } from '@angular/common/http';
import { LogTrackDialogComponent } from './log-track-dialog/log-track-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgDialogAnimationService } from 'ng-dialog-animation';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatInputModule } from '@angular/material/input';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DialogDeleteFilterComponent } from './dialog-delete-filter/dialog-delete-filter.component';
import { MatSelectModule } from '@angular/material/select';
import { MonthCalendarComponent } from './month-calendar/month-calendar.component';



// export const MY_DATE_FORMAT = {
//   parse: {
//     dateInput: 'LL',
//   },
//   display: {
//     dateInput: 'DD MMMM YYYY',

//   },
// };

// Custom date format
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD-MM-YYYY', // format you type in
  },
  display: {
    dateInput: 'DD-MM-YYYY', // format shown in input
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};


ModuleRegistry.registerModules([AllEnterpriseModule]);

LicenseManager.setLicenseKey(environment.ag_grid_key);


@NgModule({
  declarations: [
    LogTrackingLinkComponent,
    LogTrackingLandingComponent,
    LogTrackDialogComponent,
    DialogDeleteFilterComponent,
    MonthCalendarComponent
  ],
  imports: [
    CommonModule,
    LogtrackingRoutingModule,
    AcademicFormModule,
    AgGridModule,
    AgGridAngular,
    HttpClientModule,
    FormsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    MatSelectModule,
    ReactiveFormsModule




  ],

  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: MY_DATE_FORMATS
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'en-GB' // optional
    },
    NgDialogAnimationService
  ]


})
export class LogtrackingModule { }
